// Wrapper around `import.meta.env` so tests can mock env var reads.
export const getEnvVar = (name: string): string | undefined =>
    (import.meta.env as unknown as Record<string, string | undefined>)[name];
